import React, { HTMLAttributes, PropsWithChildren } from 'react';

import style from './MobileMenuList.module.css';

type Props = PropsWithChildren<HTMLAttributes<HTMLElement>>;

export function MobileMenuList({ children }: Props) {
    return <div className={style.list}>{children}</div>;
}
